import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const RoleBasedRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    // Проверяем viewMode
    const viewMode = localStorage.getItem('viewMode') || 'own';
    const effectiveRole = (viewMode === 'employee' && ['customer', 'supplier', 'support'].includes(user.role)) 
      ? 'employee' 
      : user.role;

    // Редиректим в зависимости от роли
    switch (effectiveRole) {
      case 'admin':
        navigate('/dashboard');
        break;
      case 'employee':
        navigate('/menu');
        break;
      case 'customer':
        navigate('/reports'); // Заказчик попадает в отчеты
        break;
      case 'customer_manager':
        navigate('/orders');
        break;
      case 'supplier':
      case 'support':
        navigate('/profile');
        break;
      case 'delivery':
        navigate('/delivery-dashboard');
        break;
      default:
        navigate('/login');
    }
  }, [user, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Загрузка...
    </div>
  );
};

export default RoleBasedRedirect;

